<template>
  <div>
    <h2>Владельцам сайтов: изменения в Законе «О персональных данных»</h2>

    <p>Уважаемые партнеры!</p>
    <p>
      Сообщаем Вам, что с <span class="text-bold">1 июля 2017 года</span> вступает в силу Федеральный закон от 07.02.2017 <span class="text-bold"><a
        href="//www.consultant.ru/cons/cgi/online.cgi?req=doc&amp;base=LAW&amp;n=215651&amp;rnd=261745.92459444&amp;dst=101137&amp;fld=134#0"
        target="_blank"
        rel="nofollow noopener"
      >№ 13-ФЗ</a> об обработке персональных данных</span>, согласно которому, размер штрафа для компаний, работающих с персональными данными через форму обратной связи сайта без соблюдения политики конфиденциальности, <span class="text-bold">увеличится в 7 раз</span>!
    </p>
    <p>Размещение любых форм обратной связи на сайте расценивается как сбор информации о гражданах. Это значит, что все владельцы сайтов, на которых есть личные кабинеты, формы обратной связи, подписки или регистрации, возможность покупки, размещения объявлений, заполнения анкет, являются операторами персональных данных.</p>

    <p>Если на сайте есть даже одна кнопка для заказа звонка или отправки сообщения, компания будет считаться оператором персональных данных, и обязана разместить на сайте в открытом доступе информацию о политике конфиденциальности и получить согласие пользователей на обработку их персональных данных.</p>

    <p class="text-bold">
      С 1 июля 2017 года за несоблюдение данного закона на компанию может быть наложен штраф в размере до 75&nbsp;000 рублей!
    </p>

    <p>
      Для того чтобы Ваш сайт соответствовал требованиям <a
        class="text-bold"
        href="https://b-152.ru/152-FZ_O_personalnykh_dannykh"
        target="_blank"
        rel="nofollow noopener"
      >152-ФЗ</a>, убедитесь, что выполняются следующие условия:
    </p>

    <ul class="marked">
      <li>хостинг и база данных с персональными данными должна располагаться на территории России.</li>
      <li>под каждой формой сбора данных, включая сбор email, необходимо разместить текст «Нажимая на кнопку, Вы даете согласие на обработку своих персональных данных». В тексте должна быть ссылка на документ — пользовательское соглашение, договор или согласие на обработку персональных данных. Текст самого документа можно разместить на отдельной странице.</li>
    </ul>

    <p>Согласно ч. 4 ст. 9 Закона № 152-ФЗ «О персональных данных» в тексте документа обязательно должна быть следующая информация:</p>

    <ul class="marked">
      <li><span class="text-bold">наименование или фамилия, имя, отчество и адрес оператора (то есть Вашей компании)</span>, получающего согласие субъекта персональных данных;</li>
      <li><span class="text-bold">цель обработки</span> персональных данных;</li>
      <li><span class="text-bold">перечень персональных данных</span>, на обработку которых дается согласие субъекта персональных данных;</li><li><span class="text-bold">наименование или фамилия, имя, отчество и адрес лица, осуществляющего обработку</span> персональных данных по поручению оператора, если обработка будет поручена такому лицу;</li>
      <li><span class="text-bold">перечень действий с персональными данными</span>, на совершение которых дается согласие, общее описание используемых оператором способов обработки персональных данных;</li>
      <li><span class="text-bold">срок, в течение которого действует согласие</span> субъекта персональных данных, а также способ его отзыва, если иное не установлено федеральным законом;</li>
      <li>также нужно указать информацию о том, как физическое лицо может отозвать свое согласие на обработку персональных данных.</li>
    </ul>

    <p>Все последствия, связанные с несоблюдением законодательства, несет владелец сайта.</p>
  </div>
</template>

<script>
export default {
  name: 'PersonalData'
}
</script>
